
import { defineComponent, onMounted, ref, reactive,computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig, {getMenu, adminMenu, getUserMenu} from "@/core/config/MainMenuConfig";
import PartnerViewMenu from "@/layout/aside/PartnerViewMenu.vue"
import {role} from "@/helpers/role"

export default defineComponent({
  name: "kt-menu",
  components: {
    PartnerViewMenu
  },
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();
    const scrollElRef = ref<null | HTMLElement>(null);
    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const currentUser = store.getters.currentUser;

    const selectPartner = computed(() => store.getters.getRepresentId);

    // const currentRole = ref(store.getters.currentRole) 
    const currentRole = computed(() => store.getters.currentRole);
    
    let mainMenuConfig = reactive(getMenu())
    if(currentUser.role == "Admin") {
      mainMenuConfig = adminMenu
    } else {
      mainMenuConfig = getUserMenu()
    }
    
    // watch(currentRole, (cr) => {
    //   console.log("watch", "cr", cr)
    //   mainMenuConfig.splice(0,mainMenuConfig.length);
    //   mainMenuConfig.push(...getMenu())
    // }) 

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    

    const hasActiveChildren = (match) => {
      return route.path === match || route.path.startsWith(match + '/');
    };

    const chackRole = (roles: string[]): boolean => {
      return !roles || !roles.length || roles.includes(currentUser.role);
    };

    return {
      hasActiveChildren,
      mainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      chackRole,
      selectPartner,
      currentRole
    };
  },
});
